export default __webpack_public_path__ + "static/media/start.b43a86f0.mp3";